export default "__VITE_ASSET__3jwOXb9V__"